import { endOfDay, startOfDay, subMonths } from "date-fns/esm";

import { PeriodValue } from "ds/components/Datepicker/types";

import { getCSVDownloadMaxDate, getCSVDownloadMinDate } from "./utils";

enum CSVDownloadDateRange {
  Last6Months = "Last6Months",
  Last3Months = "Last3Months",
  LastMonth = "LastMonth",
}

// The datepicker appends its own "Custom" entry after these.
export const PERIODS: Record<CSVDownloadDateRange, PeriodValue> = {
  [CSVDownloadDateRange.Last6Months]: {
    label: "Last 6 months",
    range: () => ({ start: getCSVDownloadMinDate(), end: getCSVDownloadMaxDate() }),
  },
  [CSVDownloadDateRange.Last3Months]: {
    label: "Last 3 months",
    range: () => ({ start: startOfDay(subMonths(new Date(), 3)), end: endOfDay(new Date()) }),
  },
  [CSVDownloadDateRange.LastMonth]: {
    label: "Last month",
    range: () => ({ start: startOfDay(subMonths(new Date(), 1)), end: endOfDay(new Date()) }),
  },
};

export const INITIAL_PERIOD = CSVDownloadDateRange.LastMonth;
